module.exports = __webpack_public_path__ + "logo-scroll.png?430bb44150a9e45b0d55357e722fc0b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-scroll.png
// module id = 80
// module chunks = 0